<template>
  <div>
    <div class="gl_title_bar">
      <div class="gl_tb_left">
        <span class="normaltitle">兑换入口</span>
      </div>
      <div class="gl_tb_right display_center">
        <input type="text"
               name=""
               id=""
               v-model="convercode"
               value=""
               class="searchInput" />
        <span class="searchbtn"
              @click="changecon()">兑换</span>
      </div>
    </div>
    <div v-if="Doctrecod.length == 0"
         class="NoneData">
      <p>
        <i class="iconfont icon-wushujutanhao"></i>
        <span>暂无相关数据</span>
      </p>
    </div>
    <div v-else>
      <div class="titleBar display_flex marginTop20">
        <div class="publ_left">
          <div class="publ_check marginLeft20">
            商品
          </div>
        </div>
        <div class="flex1 display_center">
          兑换码
        </div>
        <div class="flex1 display_center">
          兑换时间
        </div>
        <div class="flex1 display_center">
          操作
        </div>
      </div>
      <div class="pub_line"
           v-for="(item, index) in Doctrecod"
           :key="index">
        <div class="publ_left">
          <img :src="item.coverPict"
               style="width:122px; height:64px"
               class="publ_logo marginLeft20">
          <span class="publ_title">{{ item.title }}</span>
        </div>
        <div class="flex1 display_center">
          {{ item.cdkeyCode }}
        </div>
        <div class="flex1 display_center">
          {{ item.createDate }}
        </div>
        <div class="flex1 display_center">
          <span class="gl_pad_btn  rightBtn"
                v-if="item.type == 2"
                @click="TomenuDetail(item.commId)">去学习</span>
          <span class="gl_pad_btn  rightBtn"
                v-if="item.type == 1"
                @click="Tomenuvip()">查看</span>
        </div>
      </div>
      <pagination :total="page.total"
                  :limit="page.pageSize"
                  :page="page.currentPage"
                  @page-change="pageChange">
      </pagination>
    </div>
  </div>
</template>

<script>
export default {
  inject: ['reload'],
  name: "userExchange",
  data () {
    return {
      apiData: [],
      AuthorId: '',
      convercode: '',
      // 医生圈兑换记录
      // 1-会员 2-课程
      page: {
        total: 0,
        pageSize: 5,
        currentPage: 1,
      },
      Doctrecod: [],
      userType: 0
    }
  },
  created () {
    if (localStorage.getItem('ResData')) {
      this.AuthorId = JSON.parse(localStorage.getItem('ResData')).id
      this.userType = localStorage.getItem('userType')
    }
    this.getChangesion()
  },
  methods: {
    // 点击订单跳转详情
    TomenuDetail (id) {
      let url = this.httphelper.IsDebugCgphome() + '/detail?courseId=' + id;
      window.open(url);
    },
    // 查看兑换vip
    Tomenuvip () {
      this.$router.push({
        path: '/user/userVip'
      })
    },
    // 兑换课程
    // 205 兑换码不存在 206 兑换码已被使用 207 兑换码已失效 200-兑换成功
    changecon () {
      if (this.convercode == '') {
        this.$message({
          message: '兑换码不可为空',
          type: 'warning'
        })
      } else {
        this.httphelper.post('/api/RedeemCodeApi/ExchangeCourse',
          {
            conversionCode: this.convercode,
            userId: this.AuthorId
          }).then((res) => {
            if (res.data.code == 200) {
              this.$confirm('兑换成功， 前往我的课程医生圈课程或者VIP中心查看', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(() => {
                this.convercode = ''
                this.getChangesion()
                this.reload()
              })
            } else if (res.data.code == 205) {
              this.$message({
                message: '兑换码不存在',
                type: 'warning'
              })
              this.convercode = ''
            } else if (res.data.code == 206) {
              this.$message({
                message: '兑换码已被使用',
                type: 'warning'
              })
              this.convercode = ''
            } else if (res.data.code == 207) {
              this.$message({
                message: '兑换码已失效',
                type: 'warning'
              })
              this.convercode = ''
            } else if (res.data.code == 208) {
              this.$message({
                message: '您已有该课程,请勿重复兑换',
                type: 'warning'
              })
              this.convercode = ''
            }
          })
      }
    },
    // 获取兑换内容
    getChangesion () {
      this.httphelper.post('/api/RedeemCodeApi/GetConveriseonPageList',
        {
          userId: this.AuthorId,
          page: this.page.currentPage,
          limit: this.page.pageSize,
        }).then((res) => {
          this.Doctrecod = res.data.data
          this.Doctrecod.forEach((item) => {
            if (item.type == 1) {
              this.getInfo()
            }
          })
          this.page.total = res.data.totalcount
        })
    },
    // 点击分页
    pageChange (val) {
      this.page.currentPage = val;
      this.getChangesion()
      let osTop = document.documentElement.scrollTop || document.body.scrollTop;
      let ispeed = Math.floor(-osTop / 1.0);
      document.documentElement.scrollTop = document.body.scrollTop =
        osTop + ispeed;
      this.isTop = true;
    },
    // 获取用户信息
    getInfo () {
      this.httphelper.post('/api/CGpUserApi/GetUserMessage',
        {
          id: this.AuthorId
        }).then((res) => {
          var aData = new Date();
          var CurrentDategetTime = 0
          var VipEdDategetTime = 0
          if (res.data.data.memberDate.m_EndDate) {
            var CurrentDate = aData.getFullYear() + '-' + (aData.getMonth() + 1) + '-' + aData.getDate() + ' ' + aData.getHours() + ':' + aData.getMinutes() + ':' + aData.getSeconds();
            var VipEdDate = res.data.data.memberDate.m_EndDate;
            CurrentDategetTime = new Date(CurrentDate.replace(/-/g, '/')).getTime() / 1000;
            VipEdDategetTime = new Date(VipEdDate.replace(/-/g, '/')).getTime() / 1000;
          }
          if (res.data.data.memberDate.m_EndDate == null || parseInt(CurrentDategetTime) - parseInt(VipEdDategetTime) >= 0) {
            this.userType = 0;
          } else {
            if (res.data.data.memberDate.m_Type == 1) {
              this.userType = 1;
            } else if (res.data.data.memberDate.m_Type == 2) {
              this.userType = 2;
            } else {
              this.userType = 0;
            }
          }
          localStorage.setItem('userType', this.userType);
        })
    },
  }
}
</script>

<style scoped>
.NoneData {
    padding: 40px;
    text-align: center;
    color: #999;
    font-size: 18px;
    letter-spacing: 1px;
}

.NoneData i {
    font-size: 36px;
    color: #4da9e8;
    position: relative;
    top: 7px;
    margin-right: 7px;
}

.titleBar {
    height: 40px;
    background: #f2f4f7;
    line-height: 40px;
}

.rightBtn {
    border: 1px solid #0b8586;
    border-radius: 15px;
    cursor: pointer;
    color: #0b8586;
}

.rightBtn:hover {
    background-color: #0b8586;
    color: #fff;
}

.searchInput {
    width: 196px;
    height: 34px;
    border: 1px solid #e5e5e5;
    border-radius: 5px;
    outline: none;
    box-sizing: border-box;
}

.searchbtn {
    width: 71px;
    height: 32px;
    background: #0b8586;
    border: 1px solid #0b8586;
    border-radius: 0px 5px 5px 0px;
    cursor: pointer;
    display: inline-block;
    line-height: 32px;
    text-align: center;
    color: #fff;
}
</style>
